import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// The language select holds the same page in each language as option values.
export default class extends Controller {
  go() {
    Turbo.visit(this.element.value);
  }
}
